<template>
  <c-modal title="Change email address" :show="show" @update:show="toggle">
    <p class="lead">
      Please enter the new email address. A confirmation email will be sent to the new address with instructions to
      complete the change.
    </p>
    <c-form>
      <c-input
        v-model="newEmailAddress"
        autofocus
        autocomplete="off"
        label="Email address"
        type="text"
        :lazy="true"
        placeholder="Enter new email address"
        :is-valid="checkIfValid('newEmailAddress')"
        invalid-feedback="Please enter an email address in the format you@email.com"
      />
    </c-form>

    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" @click="sendRequest">
          <c-spinner v-if="isRequesting" color="success" size="sm" />
          <span v-else>Send change request</span>
        </c-button>
        <c-button v-if="!isRequesting" color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'UsernameChange',
  mixins: [validationMixin],
  props: {
    user: Object,
    show: Boolean,
  },
  data() {
    return {
      isRequesting: false,
      newEmailAddress: '',
    };
  },
  validations: {
    newEmailAddress: {
      required,
      email,
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    reset() {
      this.newEmailAddress = '';
    },
    close() {
      this.newEmailAddress = '';
      this.$emit('close');
    },
    sendRequest() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isRequesting = true;
      const data = {
        userId: this.user._id,
        newUsername: this.newEmailAddress,
      };
      this.$http
        .post(buildEndpoint('my-account/username-change-request'), data)
        .then((response) => {
          this.isRequesting = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Email change request has been sent to the new email address.',
            });
            this.reset();
            this.$emit('close');
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.$v.$reset();
        });
    },
  },
};
</script>
